<template>
  <Dialog>
    <div
      class="fixed inset-0 z-30"
      :class="loading ? 'pointer-events-none' : ''"
      :style="{
        backgroundColor: 'rgba(0,0,0,.7)'
      }"
    >
      <MobileView>
        <div class="w-full h-full flex flex-col items-center justify-center p-4">
          <slot />
        </div>
      </MobileView>
    </div>
  </Dialog>
</template>

<script lang="ts">
import { Dialog } from '@headlessui/vue';
import { defineComponent } from 'vue';

import { useLoader } from '@/hooks/use_loader';

import MobileView from './MobileView.vue';

export default defineComponent({
  name: 'BaseDialog',
  components: {
    Dialog,
    MobileView,
  },
  setup() {
    const { loading } = useLoader();
    return {
      loading,
    };
  },
});
</script>
